<div class="main-wrapper">
  <div class="pref-score-wrapper">
    <span
      class="line"
      [class.color-green]="prefScore >= 3.5"
      [class.color-yellow]="prefScore < 3.5 && prefScore >= 2.5"
      [class.color-red]="prefScore < 2.5"
      [style.width]="prefScore * 20 + '%'"
    ></span>
  </div>
  <p class="pref-score">{{ prefScore | number: '1.1-1' }}</p>
</div>
